import { useEffect } from 'react';
import { useGlobalAutoRefreshStore } from '../stores/useGlobalAutoRefreshStore';
import './ApplicationSettings.css';
import DashboardBottomLogo from './DashboardBottomLogo';
import SectionTitle from './shared/SectionTitle';
import StandaloneSection from './shared/StandaloneSection';

type RefreshInterval = 5 | 10 | 30 | 60;

const ApplicationSettings = () => {
  const setActiveDashboard = useGlobalAutoRefreshStore((state) => state.setActiveDashboard);
  const intervalSeconds = useGlobalAutoRefreshStore((state) => state.intervalSeconds);
  const setIntervalSeconds = useGlobalAutoRefreshStore((state) => state.setIntervalSeconds);

  // Set this dashboard as active when mounted, clear when unmounted
  useEffect(() => {
    setActiveDashboard('settings');
    return () => setActiveDashboard(null);
  }, [setActiveDashboard]);

  const intervals: RefreshInterval[] = [5, 10, 30, 60];

  const handleIntervalChange = (interval: RefreshInterval) => {
    setIntervalSeconds(interval);
  };

  return (
    <div className="application-settings">
      <div className="dashboard-header">
        <SectionTitle title="Application Settings" />
      </div>

      <div className="dashboard-content">
        <StandaloneSection title="AUTO-REFRESH SETTINGS">
          <div className="settings-content">
            <p className="settings-description">
              Configure the auto-refresh interval for all dashboards. This setting controls how frequently data is refreshed when auto-refresh is enabled.
            </p>

            <div className="settings-field">
              <label className="settings-label">Refresh Interval</label>
              <div className="interval-selector">
                {intervals.map((interval) => (
                  <button
                    key={interval}
                    className={`interval-option ${intervalSeconds === interval ? 'active' : ''}`}
                    onClick={() => handleIntervalChange(interval)}
                    type="button"
                  >
                    {interval}s
                  </button>
                ))}
              </div>
              <p className="settings-help-text">
                Current setting: Data will refresh every {intervalSeconds} seconds when auto-refresh is enabled
              </p>
            </div>
          </div>
        </StandaloneSection>
      </div>

      <DashboardBottomLogo />
    </div>
  );
};

export default ApplicationSettings;

